<template>
  <div class>
    <div class="table-page-search-wrapper" style="">
      <a-row :gutter="12" style="margin:16px 25px;">

        <a-col class="a-large-form">
          <a-form-item label style="margin-bottom:0px">
            <a-input placeholder="请输入评论内容" style="width:100%" v-model="queryParam.content"></a-input>
          </a-form-item>
        </a-col>
        <a-col class="a-large-form">
          <a-form-item label style="margin-bottom:0px">
            <a-input placeholder="请输入昵称" style="width:100%" v-model="queryParam.chatRealName"></a-input>
          </a-form-item>
        </a-col>

        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
        <a-button type="primary" @click="handleExportXls('财务统计一览')" style="margin-right:10px;float:right;">导出</a-button>

      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="avatarAct" slot-scope="text">
          <span style="width: 50px;height: 50px;display: inline-block;border-radius: 50%;overflow:hidden;">
            <img :src="text" alt="" style="width:100%;">
          </span>
        </span>
        <span slot="contentAct" slot-scope="text">
          {{ text?JSON.parse(text).content:'-' }}
        </span>
        <!-- <span slot="action" slot-scope="text, record"> -->
        <!-- <a @click="courseChapterEdite(record.chapterId)" >删除</a> -->
        <!--<a-divider type="vertical" />
          <a-popconfirm title="确定下架吗?" @confirm="() => courseChapterDel(record.chapterId)">
            <a>删除章节</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="courseHoursCreate(record.id)" v-if="record.children">新增课时</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定下架吗?" v-if="record.status==1" @confirm="() => chapterShelf(record.chapterId)">
            <a>下架</a>
          </a-popconfirm>

          <a-popconfirm title="确定上架吗?"  v-else @confirm="() => chapterShelf(record.chapterId)">
            <a>上架</a>
          </a-popconfirm>-->
        <!-- </span> -->
      </a-table>
    </div>
  </div>
</template>

<script>
import { courseConnect, courseCommon } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'dayjs'

export default {
  name: 'OnlineUserTalkList',
  mixins: [JeecgListMixin],
  data() {
    return {
      description: '讨论',
      firstIsNotLoad: true,
      studyCount: 0,
      buyCount: 0,
      studyPersonCount: 0,
      lastStudyTimeSt: '',
      url: {
        list: '/magic/liveCourse/discuss',
        delete: '/course/connect/do'
        // deleteBatch: "/course/elinkxCourse/deleteBatch",
        // exportXlsUrl: "course/elinkxCourse/exportXls",
        // importExcelUrl: "course/elinkxCourse/importExcel",
      },
      queryParam: {
        chId: '',
        // busiNo:"chStudyFlow",
        content: '',
        chatRealName: ''
      },
      columns: [
        {
          title: '头像',
          align: 'center',
          dataIndex: 'avatar',
          width: 80,
          scopedSlots: {
            customRender: 'avatarAct'
          }
        },
        {
          title: '昵称',
          align: 'center',
          dataIndex: 'chatRealName',
          width: 90
        },

        {
          title: '身份',
          align: 'center',
          dataIndex: 'userIdentity',
          width: 60
        },
        {
          title: '内容',
          align: 'center',
          dataIndex: 'content',
          width: 150
          // scopedSlots: {
          //   customRender: 'contentAct'
          // }
        },
        // {
        //   title: '状态',
        //   align: 'center',
        //   dataIndex: 'st',
        //   width: 100
        // },
        {
          title: '发表时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 160,
          customRender: (text, record, index) => {
            return moment(text).format('YYYY-MM-DD HH:mm')
          }
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' },
        //   width: 300
        // }
      ],
      dataSource: [
        { realName: '', chapterName: '哈哈', chName: '学生', studyCount: '老师，webpack是什么没听太明白。', st: '', lastStudyTime: '2020-05-06 18:09:00' }
      ]
    }
  },
  created() {
    this.queryParam.chId = this.$route.query.chId
    this.loadData()
    // this.getData();
  },
  methods: {
    dateChange: function(data, data1) {
      console.log(data, data1)
      this.queryParam.lastStudyTimeBeg = data1[0]
      this.queryParam.lastStudyTimeEnd = data1[1]
    },
    onChange: checked => {
      console.log(`a-switch to ${checked}`)
    },
    getData: function(id, status) {
      courseCommon({ busiNo: 'courseDataTotal', courseId: this.queryParam.courseId }).then((res) => {
        if (res.success) {
          this.studyCount = res.result.studyCount || 0
          this.buyCount = res.result.buyCount || 0
          this.studyPersonCount = res.result.studyPersonCount || 0
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {

      })
    }
  }
}
</script>

<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .total-data{
      overflow: hidden;
    .total-data-item{
      float: left;
      width: 33.333%;
      margin:30px 0px;
      border-right: 1px solid #E7ECEF;
      &:last-child{
        border-right: none;
      }
      .p1{
        text-align:center;
        font-size: 14px;
        color: #333333;
      }
      .p2{
        text-align:center;
        color: #FA6400;
        font-size: 40px;
      }
    }
  }
</style>
